<template>
    <div class="blurb_text_popup">
        <div class="modal-backdrop"></div>
        <div class="modal modal-open unsupported-browser">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-body text-center">
                        <div class="mb-3 text-danger">
                           <i class="fa fa-user-plus" aria-hidden="true"></i>
                        </div>
                        
                        <h3 class="mb-3">Waiting Room</h3>
                        <p class="text-justify">You have joined the meeting before the scheduled start time.</p>

                        <p v-if="countdownText">The meeting will begin in <strong>{{ countdownText }}</strong>.</p>

                        <p>Please wait. You will be able to join automatically once the meeting starts.
                        </p>
                        <div class="mt-4">
                            <router-link to="/home/" class="btn btn-primary px-4">Return to Dashboard</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "before-time-joined-meeting-popup",

    props: {
        startsAt: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            countdownText: "00:00:00",
            timerInterval: null
        };
    },

    mounted() {
        this.startCountdown();
    },

    beforeDestroy() {
        this.clearTimer();
    },

    methods: {
        startCountdown() {
            this.updateCountdown();

            this.timerInterval = setInterval(() => {
                this.updateCountdown();
            }, 1000);
        },

        updateCountdown() {
            // FIX: Multiply by 1000 here because the prop is arriving as seconds (10 digits)
            const startTimeMs = Number(this.startsAt) * 1000;

            if (isNaN(startTimeMs) || startTimeMs === 0) {
                console.error("Invalid startsAt:", this.startsAt);
                this.clearTimer();
                return;
            }

            const diff = startTimeMs - Date.now();

            if (diff <= 0) {
                this.countdownText = "00:00:00";
                this.clearTimer();
                this.$emit("time-reached");
                return;
            }

            const totalSeconds = Math.floor(diff / 1000);

            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;

            this.countdownText =
                `${String(hours).padStart(2, "0")}:` +
                `${String(minutes).padStart(2, "0")}:` +
                `${String(seconds).padStart(2, "0")}`;
        },

        clearTimer() {
            if (this.timerInterval) {
                clearInterval(this.timerInterval);
                this.timerInterval = null;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.blurb_text_popup {
    a:hover {
        text-decoration: none;
    }

    .modal-backdrop {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1040;
        background-color: #000;
        opacity: .92;
    }

    .unsupported-browser {
        &.modal {
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 1050;
            overflow: hidden;
            outline: 0;

            &.modal-open {
                overflow-x: hidden;
                overflow-y: auto;
                display: block;
            }

            .modal-dialog {
                position: relative;
                width: auto;
                margin: .5rem;
                pointer-events: none;

                @media (min-width: 600px) {
                    max-width: 600px;
                    margin: 1.75rem auto;
                }

                &.modal-dialog-centered {
                    display: flex;
                    align-items: center;
                    min-height: calc(100% - (.5rem * 2));

                    @media (min-width: 576px) {
                        min-height: calc(100% - (1.75rem * 2));
                    }
                }

                .modal-content {
                    position: relative;
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    pointer-events: auto;
                    background-color: #000000;
                    background-clip: padding-box;
                    border: none;
                    border-radius: .3rem;
                    outline: 0;
                    -webkit-box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
                    box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);

                    .modal-body {
                        padding: 25px;

                        @media (max-width: 575px) {
                            padding: 15px;
                        }
                        .fa{color: #ffc800;font-size:42px;}

                        h3 {
                            color: #ffc800;
                            font-weight: 600;
                            letter-spacing: 1px;
                            line-height: 1.6;
                            font-size: 18px;
                            text-transform: uppercase;

                            @media (max-width: 575px) {
                                font-size: 18px;
                                line-height: 1.3;
                            }
                        }

                        p {
                            letter-spacing: 1px;
                            color: #ffffff;
                            font-weight: normal;
                            font-size: 18px;
                            font-family: 'MyriadProRegular', 'Lato', sans-serif;
                            line-height: 1.3;
                            margin-bottom: 12px;

                            @media (max-width: 575px) {
                                font-size: 13px;
                            }
                        }

                        a {
                            color: #2baeff;

                            &:hover {
                                text-decoration: none;
                                color: #ffd700;
                            }
                        }

                        .btn {
                            background: #ffc800 !important;
                            border: none !important;
                            color: #000 !important;
                            box-shadow: none !important;
                            font-size: 18px;
                            font-weight: 600;
                            font-family: 'MyriadProRegular', 'Lato', sans-serif;
                            letter-spacing: 1px;

                            &:hover {
                                background: #87cefa !important;
                                color: #22292f !important;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>